import { Component, OnInit, Renderer2 } from '@angular/core';
import { CoreService } from '../../../../helper/core/core.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { BuNameService } from '../../../../helper/core/bu-name.service';
import { UserService } from '../../../../helper/core/user.service';
import { UtilsService } from '../../../../helper/utils/utils.service';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Constant } from '../../../../helper/core/constant';
import { EventService } from '../../controller/event.service';
import { TealiumUtagService } from '../../../../tealium/utag.service';
import { ConfigService } from '../../../../config.service';

@Component({
  selector: 'app-register-confirm',
  templateUrl: './register-confirm.component.html',
  styleUrls: []
})
export class RegisterConfirmComponent implements OnInit {

  public idSlot: string = "";
  public idRegistration: any;
  public idUser: any;
  public event: any = false;
  public calendar: any;
  public errorMsg: string = "";
  public errorApi: boolean = false;
  public timezone: string;
  public invitationDone: boolean = false;
  public config: any;

  shareForm: FormGroup;
  shareEmail: FormControl;

  constructor(
    private builder: FormBuilder,
    private constant: Constant,
    private coreService: CoreService,
    private route: ActivatedRoute,
    private router: Router,
    private buNameService: BuNameService,
    private userService: UserService,
    private utils: UtilsService,
    public EventController: EventService,
    private tealium: TealiumUtagService,
    private configService: ConfigService,
    private renderer: Renderer2,
  ) {
  }

  ngOnInit() {
    window.scroll(0, 0);

    // On récupère l'id du Slot
    this.route
      .queryParamMap
      .subscribe((params: ParamMap) => {
        this.idSlot = params.get('id');
        this.idRegistration = params.get('user');
      });

    /**
     * On appelle les informations de l'évènements
     * En fonction du crénau choisi
     */
    this.getSlotInformation(this.EventController.dataForm.chosenDateId);

    registerLocaleData(localeFr, 'fr');

    // Validator du champ email
    this.shareEmail = new FormControl('', [
      Validators.required,
      Validators.pattern(this.constant.emailPattern)
    ]);
    // Construction de la composition du formulaire
    this.shareForm = this.builder.group({
      email: this.shareEmail,
    });

    let typeEvent = this.EventController.event.type == 'physical' ? 'en_physique' : 'en_ligne'
    this.tealium.view("confirmation_rdv", document.title, this.EventController.event.buSlug, typeEvent, this.EventController.event.trackingId);
  }

  /**
   * API Récupère les informations
   * de l'évènement par l'id du Slot
   * @param idSlot | String : id du Slot
   */
  private getSlotInformation(idSlot): void {
    this.coreService.getSlot(idSlot).subscribe(
      (data) => {

        // Attribution des éléments de event
        this.event = data;
        this.calendar = data.calendarLinks;
        this.timezone = data.currentGmt;

        this.EventController.dataForm.remainingPlaces = data.remainingPlaces

      }, (dataError) => {
        this.errorApi = true;
      });
  }

  /**
   * Envoie les infos utag
   * @param track_zone | string : Nom du tracking
   * @param track_nom | string : Nom du tracking
   * @param track_cible | string : Slug du tracking
   */
  public sendLink(track_zone, track_nom, track_cible = "") {
    this.tealium.link({
      'track_zone': this.route.snapshot.paramMap.get('bu') + '_' + track_zone,
      'track_nom': track_nom,
      'track_cible': window.location.href + '/' + track_cible
    });
  }

  onSubmit() {
    if (this.shareForm.valid) {

      // On request pour se désinscrire
      const obj = {
        idRegistration: this.EventController.dataForm.idRegistration,
        email: this.shareEmail.value,
      };
      this.errorMsg = "";

      // Api de désinscription
      this.coreService.shareASlot(this.EventController.dataForm.chosenDateId, obj).subscribe(
        () => {
          this.errorMsg = "Votre invitation a bien été envoyée.";
          this.invitationDone = true;
        }, (dataError) => {
          // Message d'erreur de désinscription
          this.errorMsg = dataError;
          this.utils.scrollTo(".header__container");
        });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/screens/register-event/view/register-confirm/register-confirm.component.ts